module.exports = __webpack_public_path__ + "static/media/about-4.16c49b2d.png";